export function selectViewUnreadCountOffsets(state) {
  return state.findAndFilterData.viewUnreadStatus.countOffsetsByViewId;
}
export function selectViewUnreadTrackedThreads(state) {
  return state.findAndFilterData.viewUnreadStatus.trackedThreadsByViewId;
}